import { Button } from "@brightagency/headstart-common";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRounded from "@mui/icons-material/StarRounded";
import React from "react";
import styled, { keyframes } from "styled-components";
import createPersistedState from "use-persisted-state";
import { siteId } from "../../constants";
import { ANALYTICS_IDS } from "../../constants/analytics";
import { colors } from "../../utils/colors";
import { useSavedItems } from "../../utils/hooks";
import { Notification } from "../molecules/Notification";

const useSavedItemNotificationSeen = createPersistedState(
    `headstart.${siteId}.saved-item-notification.seen`,
);

const GrowFadeKeyframes = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
        transform: scale(3);
    }
`;

const GrowFade = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    animation: 350ms ease ${GrowFadeKeyframes};
    padding-left: 0.25px;
`;

export const SaveItemButton = (props: { id: number; size?: "regular" | "large" }) => {
    const { size = "regular" } = props;
    const [hasSeenNotificationBefore, setHasSeenNotificationBefore] = useSavedItemNotificationSeen(
        false,
    );
    const { isItemSaved, toggleSaved } = useSavedItems();
    const [isNotificationVisible, setIsNotificationVisible] = React.useState(false);
    return (
        <>
            <div className="save-item" style={{ position: "relative" }}>
                <Button
                    id="save-item"
                    data-analytics-id={
                        isItemSaved(props.id)
                            ? ANALYTICS_IDS.serviceUnsave
                            : ANALYTICS_IDS.serviceSave
                    }
                    onClick={(event: Event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        toggleSaved(props.id);
                        if (!hasSeenNotificationBefore) {
                            setIsNotificationVisible(true);
                        }
                    }}
                    style={{
                        width: size === "large" ? 58 : 46,
                        height: size === "large" ? 58 : 46,
                        padding: 0,
                        position: "relative",
                    }}
                    appearance="secondary"
                    size={size === "regular" ? "small" : "regular"}
                >
                    {isItemSaved(props.id) ? (
                        <>
                            <StarRounded />
                            <GrowFade>
                                <StarRounded />
                            </GrowFade>
                        </>
                    ) : (
                        <StarBorderRoundedIcon />
                    )}
                </Button>
            </div>
            <Notification
                isVisible={isNotificationVisible}
                title="Resource saved"
                content="Resources are saved until you reset your browser. Click the ‘Saved’ button in the menu to view your resources."
                icon={
                    <div
                        style={{
                            backgroundColor: colors.brandDark,
                            width: 60,
                            height: 60,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                        }}
                    >
                        <StarRounded fontSize="large" htmlColor="white" />
                    </div>
                }
                onConfirm={() => {
                    setIsNotificationVisible(false);
                    setHasSeenNotificationBefore(true);
                }}
            />
        </>
    );
};
